"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var TransactionRequest_1 = require("../../TransactionRequest");
var VechainVip180TransactionRequest = /** @class */ (function (_super) {
    tslib_1.__extends(VechainVip180TransactionRequest, _super);
    function VechainVip180TransactionRequest() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.expiration = 0;
        _this.clauses = [];
        return _this;
    }
    return VechainVip180TransactionRequest;
}(TransactionRequest_1.TransactionRequest));
exports.VechainVip180TransactionRequest = VechainVip180TransactionRequest;
//# sourceMappingURL=VechainVip180TransactionRequest.js.map